import { useActionRunner } from '../../hooks/useActionRunner'
import { redriveTenantGroup } from '../../services/api/redriveTenantGroup'
import { ActionFeedback } from '../../components/ActionFeedback/ActionFeedback'

export function RedriveTenantGroupPage() {
  const { run, isSubmitting, feedback } = useActionRunner()

  async function handleRedrive() {
    if (isSubmitting) {
      return
    }
    await run(redriveTenantGroup)
  }

  return (
    <div className="redrive-tenant-group-page">
      <div className="alert alert-info" role="note">
        This redrives tenant_group events for all tenant groups in the env.
      </div>

      <ActionFeedback feedback={feedback} />

      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          disabled={isSubmitting}
          onClick={handleRedrive}
        >
          {isSubmitting && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
          )}
          Redrive all tenant groups
        </button>
      </div>
    </div>
  )
}
